/*
 * JK – Weitere Artikel laden
 * Juwelier Kleinschnitz
 */

(() => {
  'use strict';

  const controlSelector = '[data-jks-collection-load-more]';
  const listSelector =
  '.collection__results product-list.product-list';
  const backToTopSelector =
  '[data-jks-collection-back-to-top]';

  function calculateProgress(loaded, total) {
    if (total <= 0) {
      return 0;
    }

    return Math.min(100, Math.round((loaded / total) * 100));
  }

  function updateDisplay(control) {
    const loaded = Number(control.dataset.loaded || 0);
    const total = Number(control.dataset.total || 0);

    const countElement = control.querySelector(
      '[data-jks-load-more-count]'
    );

    const progressBar = control.querySelector(
      '[data-jks-load-more-bar]'
    );

    const button = control.querySelector(
      '[data-jks-load-more-button]'
    );

    const nextUrl = control.dataset.nextUrl || '';

    if (countElement) {
      countElement.textContent =
        `${loaded} von ${total} Artikeln angezeigt`;
    }

    if (progressBar) {
      const progress = calculateProgress(loaded, total);

      progressBar.style.setProperty(
        '--jks-load-progress',
        `${progress}%`
      );
    }

if (button) {
  const finished = nextUrl === '' || loaded >= total;

  button.hidden = finished;

  if (finished) {
    button.removeAttribute('href');
  } else {
    button.setAttribute('href', nextUrl);
  }
}
  }

  function initializeControl(control) {
    if (control.dataset.jksInitialized === 'true') {
      return;
    }

    control.dataset.jksInitialized = 'true';
    control.classList.add('jks-collection-load-more--ready');

    updateDisplay(control);
  }

  function initializeAll(root = document) {
    if (root.matches?.(controlSelector)) {
      initializeControl(root);
    }

    root.querySelectorAll?.(controlSelector).forEach(
      initializeControl
    );
  }

  function setLoading(control, loading) {
    const button = control.querySelector(
      '[data-jks-load-more-button]'
    );

    const buttonText = control.querySelector(
      '[data-jks-load-more-button-text]'
    );

    control.classList.toggle(
      'jks-collection-load-more--loading',
      loading
    );

if (button) {
  button.setAttribute('aria-busy', String(loading));
  button.setAttribute('aria-disabled', String(loading));
}

    if (buttonText) {
      buttonText.textContent = loading
        ? 'Artikel werden geladen …'
        : 'Weitere Artikel laden';
    }
  }

  function showError(control) {
    const status = control.querySelector(
      '[data-jks-load-more-status]'
    );

    control.classList.add(
      'jks-collection-load-more--error'
    );

    if (status) {
      status.textContent =
        'Weitere Artikel konnten nicht geladen werden. ' +
        'Bitte verwenden Sie die Seitennavigation.';
    }
  }

  async function loadMore(control) {
    const nextUrl = control.dataset.nextUrl;

    if (!nextUrl) {
      return;
    }

    const currentSection = control.closest(
      '.shopify-section--main-collection'
    );

    const currentList = currentSection?.querySelector(
      listSelector
    );

    if (!currentSection || !currentList) {
      showError(control);
      return;
    }

    setLoading(control, true);

    const status = control.querySelector(
      '[data-jks-load-more-status]'
    );

    if (status) {
      status.textContent = '';
    }

    try {
      const response = await fetch(nextUrl, {
        method: 'GET',
        headers: {
          Accept: 'text/html'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(
          `HTTP-Fehler ${response.status}`
        );
      }

      const html = await response.text();

      const documentParser = new DOMParser();
      const nextDocument = documentParser.parseFromString(
        html,
        'text/html'
      );

      const escapedSectionId = CSS.escape(currentSection.id);

      const nextSection = nextDocument.querySelector(
        `#${escapedSectionId}`
      );

      const nextList = nextSection?.querySelector(
        listSelector
      );

      const nextControl = nextSection?.querySelector(
        controlSelector
      );

      if (!nextList || !nextControl) {
        throw new Error(
          'Die nächste Produktseite wurde nicht gefunden.'
        );
      }

      /*
       * Nur Produktkarten übernehmen.
       * Dadurch werden eventuelle Werbeblöcke nicht auf jeder
       * nachgeladenen Seite erneut eingefügt.
       */

      const newProducts = Array.from(
        nextList.children
      ).filter((element) => {
        return element.matches('product-card');
      });

      if (newProducts.length === 0) {
        throw new Error(
          'Es wurden keine weiteren Artikel gefunden.'
        );
      }

 const fragment = document.createDocumentFragment();
let firstAddedProduct = null;

newProducts.forEach((productCard) => {
  const importedProduct = document.importNode(
    productCard,
    true
  );

  if (!firstAddedProduct) {
    firstAddedProduct = importedProduct;
  }

  fragment.appendChild(importedProduct);
});

currentList.appendChild(fragment);

      const previousLoaded = Number(
        control.dataset.loaded || 0
      );

      control.dataset.loaded = String(
        previousLoaded + newProducts.length
      );

      control.dataset.total =
        nextControl.dataset.total ||
        control.dataset.total;

      control.dataset.nextUrl =
        nextControl.dataset.nextUrl || '';

      updateDisplay(control);

      if (firstAddedProduct) {
  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  window.requestAnimationFrame(() => {
    firstAddedProduct.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  });
}

      /*
       * Eigenes Ereignis für unsere vorhandenen Erweiterungen,
       * beispielsweise KI-Kennzeichnung oder Bewertungs-Snippets.
       */

      document.dispatchEvent(
        new CustomEvent('jks:collection-products-loaded', {
          detail: {
            productList: currentList,
            addedProducts: newProducts.length
          }
        })
      );
    } catch (error) {
      console.error(
        'JK Weitere Artikel laden:',
        error
      );

      showError(control);
    } finally {
      setLoading(control, false);
    }
  }

document.addEventListener('click', (event) => {
  const button = event.target.closest(
    '[data-jks-load-more-button]'
  );

  if (!button) {
    return;
  }

  const control = button.closest(controlSelector);

  if (!control) {
    return;
  }

  /*
   * Mit JavaScript werden die Artikel unterhalb ergänzt.
   * Ohne JavaScript funktioniert der Link ganz normal
   * und öffnet die nächste Seite.
   */
  event.preventDefault();

  if (
    control.classList.contains(
      'jks-collection-load-more--loading'
    )
  ) {
    return;
  }

  loadMore(control);
});

  /*
   * Impact ersetzt bei Filtern und Sortierung Teile der
   * Kollektionsseite. Neue Ladebereiche werden deshalb
   * automatisch erneut erkannt.
   */

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          initializeAll(node);
        }
      });
    });
  });

/*
 * Die Position und die Sichtbarkeit werden getrennt
 * berechnet. Dadurch springt der Pfeil nicht, wenn Safari
 * beim Scrollen seine Adressleiste ein- oder ausblendet.
 */

function updateBackToTopPosition() {
  const filterButton = document.querySelector(
    'facet-floating-filter ' +
    'button[aria-controls="facets-drawer"], ' +
    '.facets__floating-filter ' +
    'button[aria-controls="facets-drawer"]'
  );

  let alignedBottom = null;

  if (filterButton) {
    const filterRect =
      filterButton.getBoundingClientRect();

    const filterCenter =
      filterRect.top + filterRect.height / 2;

    const backToTopButtonHeight = 46;

    alignedBottom = Math.max(
      10,
      window.innerHeight -
        filterCenter -
        backToTopButtonHeight / 2
    );
  }

  document.querySelectorAll(
    backToTopSelector
  ).forEach((button) => {
    if (alignedBottom !== null) {
      button.style.setProperty(
        '--jks-back-to-top-bottom',
        `${alignedBottom}px`
      );
    } else {
      button.style.removeProperty(
        '--jks-back-to-top-bottom'
      );
    }
  });
}

function updateBackToTopVisibility() {
  const footer = document.querySelector(
    '.shopify-section--footer, footer'
  );

  const footerIsVisible = footer
    ? footer.getBoundingClientRect().top <
      window.innerHeight
    : false;

  const visible =
    window.scrollY > 900 &&
    !footerIsVisible;

  document.querySelectorAll(
    backToTopSelector
  ).forEach((button) => {
    button.classList.toggle(
      'jks-collection-back-to-top--visible',
      visible
    );

    button.setAttribute(
      'aria-hidden',
      String(!visible)
    );

    button.tabIndex = visible ? 0 : -1;
  });
}

let backToTopFrameRequested = false;

window.addEventListener(
  'scroll',
  () => {
    if (backToTopFrameRequested) {
      return;
    }

    backToTopFrameRequested = true;

    window.requestAnimationFrame(() => {
      /*
       * Beim Scrollen ausschließlich Sichtbarkeit und
       * Footer prüfen. Die Position bleibt unverändert.
       */
      updateBackToTopVisibility();
      backToTopFrameRequested = false;
    });
  },
  { passive: true }
);

/*
 * Safari löst beim Ein- und Ausblenden seiner Leisten
 * teilweise ein Resize aus, obwohl sich nur die Höhe ändert.
 * Deshalb wird die Pfeilposition nur bei einer echten
 * Änderung der Bildschirmbreite neu berechnet.
 */

let backToTopViewportWidth = window.innerWidth;
let backToTopResizeFrameRequested = false;

window.addEventListener(
  'resize',
  () => {
    const currentWidth = window.innerWidth;

    if (
      Math.abs(
        currentWidth - backToTopViewportWidth
      ) < 2
    ) {
      updateBackToTopVisibility();
      return;
    }

    backToTopViewportWidth = currentWidth;

    if (backToTopResizeFrameRequested) {
      return;
    }

    backToTopResizeFrameRequested = true;

    window.requestAnimationFrame(() => {
      updateBackToTopPosition();
      updateBackToTopVisibility();

      backToTopResizeFrameRequested = false;
    });
  },
  { passive: true }
);

document.addEventListener('click', (event) => {
  const button = event.target.closest(
    backToTopSelector
  );

  if (!button) {
    return;
  }

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  window.scrollTo({
    top: 0,
    behavior: reduceMotion ? 'auto' : 'smooth'
  });
});

function start() {
  initializeAll();
  updateBackToTopPosition();
  updateBackToTopVisibility();

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    start,
    { once: true }
  );
} else {
  start();
}
})();